import { render, staticRenderFns } from "./IconAddChatUser.vue?vue&type=template&id=68620a39"
import script from "./IconAddChatUser.vue?vue&type=script&lang=js"
export * from "./IconAddChatUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports